module.exports = __webpack_public_path__ + "static/media/taskTodo.2950e989.svg";